<template>
  <div class="receiver-list">
    <div class="receiver-input" v-for="(r, index) in selectedReceivers" :key="index">
      <v-autocomplete
        v-model="selectedReceivers[index]"
        :items="receiversForSelection"
        :filter="onContributorFilter"
        no-data-text="Danh sách trống"
        item-text="name"
        item-value="user"
        placeholder="Chọn người nhận việc"
        hide-details="auto"
        class="required"
        clearable
        outlined
        dense
        @change="receiverChangeHandler"
      >
        <template #item="{ item }">
          <CardTeacher v-if="item.contributorType === 'teacher'" :teacher="item" />
          <div v-else>{{ item.name }}</div>
        </template>
      </v-autocomplete>
      <v-btn
        v-if="index === selectedReceivers.length - 1"
        icon
        @click="addReceiverClickHandler"
        color="#0D47A1"
        class="ml-2"
      >
        <v-icon>mdi-plus-circle-outline</v-icon>
      </v-btn>
      <v-btn
        v-else
        icon
        @click="removeReceiverClickHandler(index)"
        color="#FD6B6B"
        class="ml-2"
      >
        <v-icon>mdi-minus-circle-outline</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import utils from '@/plugins/utils.js'
import { textHelpers } from '@/helpers/TextHelper'
import { mapGetters } from 'vuex'
import { uniq, isEmpty, get } from 'lodash-es'
import CardTeacher from './CardTeacher.vue'

export default {
  components: { CardTeacher },
  props: {
    defaultReceivers: {
      type: Array,
      default: () => ['']
    }
  },
  data() {
    return {
      selectedReceivers: ['']
    }
  },
  computed: {
    ...mapGetters('task', ['receiversForSelection'])
  },
  mounted() {
    if (isEmpty(this.defaultReceivers)) {
      this.selectedReceivers = ['']
    } else {
      this.selectedReceivers = this.defaultReceivers
    }
  },
  methods: {
    addReceiverClickHandler() {
      this.selectedReceivers.push('')
    },
    removeReceiverClickHandler(index) {
      this.selectedReceivers.splice(index, 1)
      this.receiversChange()
    },
    /**
     * Hàm bắt sự kiện chọn hoặc hủy chọn người nhận ở v-autocomplete
     */
    receiverChangeHandler() {
      this.receiversChange()
    },
    /**
     * Khi danh sách receiver thay đổi thì lọc danh sách
     * loại bỏ các user id trống và trung lặp
     * rồi bắn sự kiện thay đổi danh sách lên component cha
     */
    receiversChange() {
      // Lọc danh sách receiver
      let receivers = this.selectedReceivers
      // Loại bỏ các receiver rỗng hoặc null
      receivers = receivers.filter(r => r)
      // Loại bỏ các receiver trùng nhau
      receivers = uniq(receivers)
      this.$emit('change', receivers)
    },
    onContributorFilter(item, queryText) {
      const searchInput = textHelpers.removeSpaces(utils.clearUnicode(queryText))
      let name = ''
      let academicLevels = ''
      let subject = ''
      if (get(item, 'name', '')) {
        name = textHelpers.removeSpaces(utils.clearUnicode(item.name))
      }
      if (get(item, 'academicLevels', '') && item.academicLevels.length) {
        academicLevels = item.academicLevels
          .map(level => textHelpers.removeSpaces(utils.clearUnicode(level.title)))
          .join(',')
      }
      if (get(item, 'subjectGroup.title', '')) {
        subject = textHelpers.removeSpaces(utils.clearUnicode(item.subjectGroup.title))
      }
      return (
        name.includes(searchInput) ||
        academicLevels.includes(searchInput) ||
        subject.includes(searchInput) ||
        item.header
      )
    }
  },
  watch: {}
}
</script>

<style lang="scss" scoped>
.receiver-list {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  .receiver-input {
    width: 100%;
    display: flex;
    align-items: center;
  }
}
</style>
